import { useState } from "react";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { ScheduleTestDriverTitle, SubmitReview } from "../../../constants";
import { useAppDispatch, useAppSelector } from "../../../reduxToolkit/hooks";
import { setDriverModal } from "../../../reduxToolkit/reducers/layoutSlice";
import CloseBtn from "../CloseBtn";
import RenderInput from "../RenderInput";

const DriverModal = () => {
  const { driverModal } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();

  // State for form fields
  const [form, setForm] = useState({
    name: "",
    email: "",
    date: "",
    time: "",
  });

  const toggle = () => dispatch(setDriverModal());

  // Handle input changes
  const handleChange = (key: string, value: string) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Check if any field is empty
    if (!form.name || !form.email || !form.date || !form.time) {
      alert("Please fill in all fields.");
      return;
    }
    // Build WhatsApp message
    const message = `Hello, my name is ${form.name}. I would like to schedule a test drive on ${form.date} at ${form.time}. My email is ${form.email}.`;
    const url = `https://wa.me/601162914913?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank", "noopener,noreferrer");
    toggle(); // Close modal after submit
  };

  return (
    <Modal fade centered modalClassName="theme-modal" isOpen={driverModal} toggle={toggle}>
      <ModalHeader toggle={toggle} close={<CloseBtn toggle={toggle} />} />
      <ModalBody>
        <h3 className="car-title">{ScheduleTestDriverTitle}</h3>
        <form onSubmit={handleSubmit}>
          <Row className="gy-3">
            <RenderInput
              placeholder="Enter Your Name"
              ColClass="col-xs-12"
              review
              value={form.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("name", e.target.value)}
            />
            <RenderInput
              placeholder="Enter Your E-mail"
              ColClass="col-xs-12"
              review
              value={form.email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("email", e.target.value)}
            />
            <RenderInput
              placeholder="Select Date"
              ColClass="col-xs-12"
              inputType="date"
              review
              value={form.date}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("date", e.target.value)}
            />
            <RenderInput
              placeholder="Select Time"
              ColClass="col-xs-12"
              inputType="time"
              review
              value={form.time}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange("time", e.target.value)}
            />
              <button
              type="submit"
              className="btn-solid"
            >
              {SubmitReview}
            </button>
            {/* <RenderInput
              button={SubmitReview}
              ColClass="col-xs-12"
              review
              inputType="submit"
            /> */}
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default DriverModal;